import { z } from "zod";

const sourceAmount = z.object({
  cell: z.string().regex(/^[A-Z]+\d+$/u).nullable(),
  value: z.number().finite().nullable(),
});

/** Excel observations, never system actuals or an additional planning target. */
export const planSourceQuantitiesSchema = z.object({
  fileHash: z.string().regex(/^[a-f0-9]{64}$/u),
  sheetName: z.string().min(1),
  sourceRow: z.number().int().positive(),
  unit: z.enum(["kg", "koli", "adet"]).nullable(),
  orderQuantity: sourceAmount,
  alreadyProduced: sourceAmount,
  remainingQuantity: sourceAmount,
});

export type PlanSourceQuantities = z.infer<typeof planSourceQuantitiesSchema>;
